import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-options-menu',
  templateUrl: './options-menu.component.html',
  styleUrls: ['./options-menu.component.scss'],
})
export class OptionsMenuComponent implements OnInit {

  @Input () headerTitle:string;
  @Input () modeFrom:string;
  @Input () address:any;
  @Input () discountPrograms:any;
  @Input () selectProgramAccount:any;

  program:any;

  constructor(private mdlCtrl:ModalController) { }

  ngOnInit() {
    if(this.selectProgramAccount)this.program=this.selectProgramAccount.id
  }

  // Modal Close
  back(){
    this.mdlCtrl.dismiss();
  }

  actionDismiss(data?:any){
    if(this.modeFrom==='program'){

      let filterValue = this.discountPrograms.filter((data)=>{
        return data.id === this.program
      })    

      this.mdlCtrl.dismiss(filterValue[0]);
    }
    else{
      this.mdlCtrl.dismiss(data)
    }
  }  


  confirm(){
    console.log(this.program);
  }

}
